import React from 'react';
import { Box, FormControl, Grid, TextareaAutosize } from '@material-ui/core';
import PropTypes from 'prop-types';
import CareerInterestInstructions from './CareerInterestInstructions';
import CareerInterestSubsection from './CareerInterestSubsection';
import { isAlumni, isStudent } from '../../../util/miscUtil';

const CareerInterests = (props) => {
  const { form, setForm, classes, auth } = props;

  if (form?.version !== 2) return null;

  const fieldDisabled = !isStudent(auth.roles) && !isAlumni(auth.roles) ? true : form.status === 'submitted' || form.status === 'approved';

  const interestKeys = ['interest1', 'interest2', 'interest3'];

  return (
    <Box sx={{ width: '90%' }} style={{ paddingBottom: '30px' }}>
      <CareerInterestInstructions classes={classes} />
      {interestKeys.map((key, idx) => (
        <CareerInterestSubsection
          key={key}
          item={{ key, name: `Career Interest ${idx + 1}` }}
          data={form.careerInterests[key]}
          setData={(updatedFields) =>
            setForm({
              ...form,
              careerInterests: {
                ...form.careerInterests,
                [key]: { ...form.careerInterests[key], ...updatedFields },
              },
            })
          }
          classes={classes}
          fieldDisabled={fieldDisabled}
        />
      ))}
      <Grid container direction='row' className={classes.unprintedContent}>
        <Grid item xs={12} className={classes.textSpacer}>
          <label style={{ fontWeight: 'bold' }}>
            Of the three careers you explored, which one are you most interested in pursuing - and why does it stand out to you?
          </label>
        </Grid>
      </Grid>
      <Grid container direction='row'>
        <Grid item xs={12} className={classes.textArea5RowSpacer + ' ' + classes.unprintedContent}>
          <FormControl fullWidth>
            <TextareaAutosize
              id='career-interests-reason'
              aria-label='Career interests reason'
              value={form.careerInterestsReason}
              minRows={2}
              maxLength={250}
              onChange={(event) => {
                setForm((prev) => ({
                  ...prev,
                  careerInterestsReason: event.target.value.slice(0, 250),
                }));
              }}
              disabled={fieldDisabled}
              className={classes.textAreaFont}
            />
          </FormControl>
        </Grid>
      </Grid>
      <div className={classes.printedContent}>
        <div>
          <label className={classes.alignPrintedContent} style={{ fontWeight: 'bold' }}>
            Of the three careers you explored, which one are you most interested in pursuing - and why does it stand out to you?
          </label>
        </div>
        <div>
          <summary className={classes.alignPrintedContent}>{form.careerInterestsReason || null}</summary>
        </div>
      </div>
    </Box>
  );
};

CareerInterests.propTypes = {
  form: PropTypes.object,
  classes: PropTypes.object,
  setForm: PropTypes.func,
  auth: PropTypes.object,
};

export default CareerInterests;
